import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2baf1c28"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=2baf1c28&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2baf1c28')) {
      api.createRecord('2baf1c28', component.options)
    } else {
      api.reload('2baf1c28', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=2baf1c28", function () {
      api.rerender('2baf1c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/Home.vue"
export default component.exports